module.exports = __webpack_public_path__ + "static/p03_becerroCabeza-04a01e22d957f1135662e8fc63085d48.png";